import { render, staticRenderFns } from "./vehicle-make-list.vue?vue&type=template&id=5489a058"
import script from "./vehicle-make-list.vue?vue&type=script&lang=js"
export * from "./vehicle-make-list.vue?vue&type=script&lang=js"
import style0 from "./vehicle-make-list.vue?vue&type=style&index=0&id=5489a058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports